export const UPDATE_PENDING_SIGNUP_INFO = 'UPDATE_PENDING_SIGNUP_INFO';
export const CLEAR_SIGNUP_INFO = 'CLEAR_SIGNUP_INFO';